import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateConfig } from '@core/config/date.config';

@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  public transform(value: any): any {
    return super.transform(value, DateConfig.DATE_FORMAT);
  }
}
